export const directions = [
  { ID: 1, Title: 'СО2' },
  { ID: 2, Title: 'Электричество' },
  { ID: 3, Title: 'Тепло' },
  { ID: 4, Title: 'Общая энергия' },
  { ID: 5, Title: 'Вода' },
];

export const blocks = [
  { ID: 1, Title: 'Использование CO2' },
  { ID: 2, Title: 'Распределение CO2' },
  { ID: 3, Title: 'Сбор CO2' },
  { ID: 4, Title: 'Сжижение CO2' },
  { ID: 5, Title: 'Филлеры' },
];

export const demands = [
  { ID: 1, Title: 'Все ли карбонаторы/блендеры (в зоне фильтрации пива или в зоне упаковки безалкогольных напитков) работают в автоматическом режиме' },
  { ID: 2, Title: 'Все ли сосуды, содержащие CO2, подключены к системе регенерации CO2 и работают ли они в автоматическом режиме' },
  { ID: 3, Title: 'Ищет ли завод активные возможности для достижения модуляции между объемом фильтрованного и объемом упакованного, чтобы избежать дисбаланса CO2 в BBT' },
  { ID: 4, Title: 'Работает ли наполнитель с расчетной скоростью, чтобы получить оптимальное рабочее потребление CO2 (если наполнитель работает медленно, все этапы CO2 станут длиннее)' },
  { ID: 5, Title: 'Вариант 5' },
];

export const meetings = [
  { ID: 1, Title: 'Совещание 1' },
  { ID: 2, Title: 'Совещание 2' },
  { ID: 3, Title: 'Совещание 3' },
  { ID: 4, Title: 'Совещание 4' },
  { ID: 5, Title: 'Совещание 5' },
];

export const focusGops = [{ ID: 1, Title: 'Да' }, { ID: 2, Title: 'Нет' },];

export const statuses = [
  { ID: 1, Title: 'Не начато' },
  { ID: 2, Title: 'В процессе' },
  { ID: 3, Title: 'Просрочено' },
  { ID: 4, Title: 'Отменено' },
  { ID: 5, Title: 'Закрыто' },
];

export const mockDataGOP = [
  {
    ID: 1,
    direction: 'Направление 1',
    block: 'Блок 1',
    demand: 'Количество внутренних и внешних отчетов по управлению отходами',
    focus: true,
    created: '01.10.2024',
    disc: '#GOPСтандарты Пройти #тренинг по безопасности',
    resp: 'Иванов И.И.',
    update: '10.12.2024',
    status: 'Не начато',
    action: 'Совещание по производственному планированию',
  },
  {
    ID: 2,
    direction: 'Направление 2',
    block: 'Блок 1',
    demand: 'Частота коммуникаций с перерабатывающими организациями',
    focus: true,
    created: '10.08.2024',
    disc: '#GOPСтандарты Внедрить систему регулярной отчетности',
    resp: 'Иванов И.И.',
    update: '11.2.2024',
    status: 'В процессе',
    action: 'Совещание по производственному планированию',
  },
  {
    ID: 3,
    direction: 'Направление 2',
    block: 'Блок 2',
    demand: 'Уровень информированности сотрудников об изменениях в политике переработки отходов',
    focus: false,
    created: '01.08.2024',
    disc: '#GOPСтандарты Пройти #тренинг-инструктаж',
    resp: 'Иванов И.И.',
    update: '15.09.2024',
    status: 'Просрочено',
    action: 'Совещание по производственному планированию',
  },
  {
    ID: 4,
    direction: 'Направление 3',
    block: 'Блок 1',
    demand: 'Количество предложений от сотрудников по улучшению энергоэффективности',
    focus: true,
    created: '02.10.2024',
    disc: '#GOPСтандарты Пройти #тренинг по безопасности',
    resp: 'Иванов И.И.',
    update: '1.12.2024',
    status: 'В процессе',
    action: 'Совещание по качеству продукции',
  },
  {
    ID: 5,
    direction: 'Направление 4',
    block: 'Блок 1',
    demand: 'Количество предложений от сотрудников по улучшению энергоэффективности',
    focus: false,
    created: '11.09.2024',
    disc: '#GOPСтандарты Внедрить систему регулярной отчетности',
    resp: 'Иванов И.И.',
    update: '10.11.2024',
    status: 'В процессе',
    action: 'Совещание по качеству продукции',
  },
  {
    ID: 6,
    direction: 'Направление 1',
    block: 'Блок 1',
    demand: 'Количество внутренних и внешних отчетов по управлению отходами',
    focus: true,
    created: '01.10.2024',
    disc: '#GOPСтандарты Пройти #тренинг по безопасности',
    resp: 'Иванов И.И.',
    update: '10.12.2024',
    status: 'Не начато',
    action: 'Совещание по производственному планированию',
  },
  {
    ID: 7,
    direction: 'Направление 1',
    block: 'Блок 1',
    demand: 'Количество внутренних и внешних отчетов по управлению отходами',
    focus: true,
    created: '01.10.2024',
    disc: '#GOPСтандарты Пройти #тренинг по безопасности',
    resp: 'Иванов И.И.',
    update: '10.12.2024',
    status: 'Не начато',
    action: 'Совещание по производственному планированию',
  },
  {
    ID: 8,
    direction: 'Направление 1',
    block: 'Блок 1',
    demand: 'Количество внутренних и внешних отчетов по управлению отходами',
    focus: true,
    created: '01.10.2024',
    disc: '#GOPСтандарты Пройти #тренинг по безопасности',
    resp: 'Иванов И.И.',
    update: '10.12.2024',
    status: 'Не начато',
    action: 'Совещание по производственному планированию',
  },
];

export const gormGOP = [
  { ID: 1, Title: 'ФОРМА GOP 1' },
  { ID: 2, Title: 'ФОРМА GOP 2' },
  { ID: 3, Title: 'ФОРМА GOP 3' },
  { ID: 4, Title: 'ФОРМА GOP 4' },
];

export const focusGop = [
  { ID: 1, Title: 'Все' },
  { ID: 2, Title: 'Только фокусные' },

];



export const factoriesForDisplayMOCK = [
  {
    Title: 'Владивосток',
    ID: 1,
    Code: 'VLA',
    VPOgroup: [
      {
        Title: 'BOP',
        ID: 1,
      },
    ],
  },
  {
    Title: 'Волжский',
    ID: 2,
    Code: 'VOL',
    VPOgroup: [
      {
        Title: 'BOP',
        ID: 1,
      },
    ],
  },
  {
    Title: 'Иваново',
    ID: 3,
    Code: 'IVA',
    VPOgroup: [
      {
        Title: 'BOP',
        ID: 1,
      },
    ],
  },
  {
    Title: 'Казань',
    ID: 4,
    Code: 'KAZ',
    VPOgroup: [
      {
        Title: 'BOP',
        ID: 1,
      },
    ],
  },
  {
    Title: 'Калуга',
    ID: 5,
    Code: 'KLG',
    VPOgroup: [
      {
        Title: 'BOP',
        ID: 1,
      },
    ],
  },
  {
    Title: 'Клин',
    ID: 6,
    Code: 'KLI',
    VPOgroup: [
      {
        Title: 'BOP',
        ID: 1,
      },
    ],
  },
  {
    Title: 'Новосибирск',
    ID: 7,
    Code: 'NOV',
    VPOgroup: [
      {
        Title: 'BOP',
        ID: 1,
      },
    ],
  },
  {
    Title: 'Омск',
    ID: 8,
    Code: 'OMS',
    VPOgroup: [
      {
        Title: 'BOP',
        ID: 1,
      },
    ],
  },
  {
    Title: 'ПЭТ Производство Казань',
    ID: 9,
    Code: 'PET',
    VPOgroup: [
      {
        Title: 'SOP',
        ID: 3,
      },
    ],
  },
  {
    Title: 'Саранск',
    ID: 10,
    Code: 'SAR',
    VPOgroup: [
      {
        Title: 'BOP',
        ID: 1,
      },
    ],
  },
  {
    Title: 'Солодовня Казань',
    ID: 11,
    Code: 'MKAZ',
    VPOgroup: [
      {
        Title: 'VOP',
        ID: 4,
      },
    ],
  },
  {
    Title: 'Солодовня Омск',
    ID: 12,
    Code: 'MOMS',
    VPOgroup: [
      {
        Title: 'VOP',
        ID: 4,
      },
    ],
  },
  {
    Title: 'Солодовня Саранск',
    ID: 13,
    Code: 'MSAR',
    VPOgroup: [
      {
        Title: 'VOP',
        ID: 4,
      },
    ],
  },
  {
    Title: 'Ульяновск',
    ID: 14,
    Code: 'ULY',
    VPOgroup: [
      {
        Title: 'BOP',
        ID: 1,
      },
    ],
  },
  {
    Title: 'Уфа',
    ID: 15,
    Code: 'UFA',
    VPOgroup: [
      {
        Title: 'BOP',
        ID: 1,
      },
    ],
  },
];

export const GopDataReportPeriod = [
  {
    ID: 5012,
    Title: 'Статус',
    ColumnID: '22',
    ColumnTitle: 'CO2',
    GroupID: '24',
    GroupTitle: 'BOP',
    FactoryID: '3',
    FactoryTitle: 'Иваново',
    Status: {
      Title: 'Завершено',
      ID: 2,
    },
    Month: '3',
    Year: '2025',
    CountYes: '201',
    CountQuestions: '896',
    CountNull: '66',
    Modified: '2025-04-09T13:10:12.000Z',
    Author: {
      Name: 'System Account',
      ID: 1073741823,
      Email: '',
    },
    IsError: true,
    AutoEndDate: null,
    AuthorEnd: {
      Name: 'Гудков Евгений Олегович',
      ID: 296,
      Email: 'evgeniy.gudkov@abinbevefes.com',
    },
  },
  {
    ID: 5014,
    Title: 'Статус',
    ColumnID: '22',
    ColumnTitle: 'CO2',
    GroupID: '24',
    GroupTitle: 'BOP',
    FactoryID: '2',
    FactoryTitle: 'Волжский',
    Status: {
      Title: 'Завершено',
      ID: 2,
    },
    Month: '3',
    Year: '2025',
    CountYes: '542',
    CountQuestions: '896',
    CountNull: '66',
    Modified: '2025-04-09T13:00:00.000Z',
    Author: {
      Name: 'System Account',
      ID: 1073741823,
      Email: '',
    },
    IsError: true,
    AutoEndDate: null,
    AuthorEnd: {
      Name: 'Гудков Евгений Олегович',
      ID: 296,
      Email: 'evgeniy.gudkov@abinbevefes.com',
    },
  },
  {
    ID: 5015,
    Title: 'Статус',
    ColumnID: '499',
    ColumnTitle: 'Люди',
    GroupID: '501',
    GroupTitle: 'BOP',
    FactoryID: '15',
    FactoryTitle: 'Уфа',
    Status: {
      Title: 'Завершено',
      ID: 2,
    },
    Month: '3',
    Year: '2025',
    CountYes: '450',
    CountQuestions: '742',
    CountNull: '111',
    Modified: '2025-04-15T15:41:52.000Z',
    Author: {
      Name: 'System Account',
      ID: 1073741823,
      Email: '',
    },
    IsError: true,
    AutoEndDate: null,
    AuthorEnd: {
      Name: 'Гудков Евгений Олегович',
      ID: 296,
      Email: 'evgeniy.gudkov@abinbevefes.com',
    },
  },
  {
    ID: 5016,
    Title: 'Статус',
    ColumnID: '499',
    ColumnTitle: 'Люди',
    GroupID: '502',
    GroupTitle: 'VOP',
    FactoryID: '13',
    FactoryTitle: 'Солодовня Саранск',
    Status: {
      Title: 'Завершено',
      ID: 2,
    },
    Month: '3',
    Year: '2025',
    CountYes: '184',
    CountQuestions: '318',
    CountNull: '48',
    Modified: '2025-04-15T15:45:23.000Z',
    Author: {
      Name: 'System Account',
      ID: 1073741823,
      Email: '',
    },
    IsError: true,
    AutoEndDate: null,
    AuthorEnd: null,
  },
  {
    ID: 5017,
    Title: 'Статус',
    ColumnID: '500',
    ColumnTitle: 'Экология',
    GroupID: '841',
    GroupTitle: 'BOP',
    FactoryID: '14',
    FactoryTitle: 'Ульяновск',
    Status: {
      Title: 'Завершено',
      ID: 2,
    },
    Month: '3',
    Year: '2025',
    CountYes: '412',
    CountQuestions: '1064',
    CountNull: '487',
    Modified: '2025-04-09T13:20:24.000Z',
    Author: {
      Name: 'System Account',
      ID: 1073741823,
      Email: '',
    },
    IsError: true,
    AutoEndDate: null,
    AuthorEnd: {
      Name: 'Гудков Евгений Олегович',
      ID: 296,
      Email: 'evgeniy.gudkov@abinbevefes.com',
    },
  },
  {
    ID: 5018,
    Title: 'Статус',
    ColumnID: '499',
    ColumnTitle: 'Люди',
    GroupID: '502',
    GroupTitle: 'VOP',
    FactoryID: '11',
    FactoryTitle: 'Солодовня Казань',
    Status: {
      Title: 'Завершено',
      ID: 2,
    },
    Month: '3',
    Year: '2025',
    CountYes: '187',
    CountQuestions: '318',
    CountNull: '48',
    Modified: '2025-04-15T15:43:05.000Z',
    Author: {
      Name: 'System Account',
      ID: 1073741823,
      Email: '',
    },
    IsError: true,
    AutoEndDate: null,
    AuthorEnd: null,
  },
  {
    ID: 5019,
    Title: 'Статус',
    ColumnID: '22',
    ColumnTitle: 'CO2',
    GroupID: '24',
    GroupTitle: 'BOP',
    FactoryID: '10',
    FactoryTitle: 'Саранск',
    Status: {
      Title: 'Завершено',
      ID: 2,
    },
    Month: '3',
    Year: '2025',
    CountYes: '523',
    CountQuestions: '896',
    CountNull: '66',
    Modified: '2025-04-08T17:37:31.000Z',
    Author: {
      Name: 'System Account',
      ID: 1073741823,
      Email: '',
    },
    IsError: true,
    AutoEndDate: null,
    AuthorEnd: null,
  },
  {
    ID: 5020,
    Title: 'Статус',
    ColumnID: '22',
    ColumnTitle: 'CO2',
    GroupID: '24',
    GroupTitle: 'BOP',
    FactoryID: '4',
    FactoryTitle: 'Казань',
    Status: {
      Title: 'Завершено',
      ID: 2,
    },
    Month: '3',
    Year: '2025',
    CountYes: '359',
    CountQuestions: '896',
    CountNull: '66',
    Modified: '2025-04-08T17:15:56.000Z',
    Author: {
      Name: 'System Account',
      ID: 1073741823,
      Email: '',
    },
    IsError: true,
    AutoEndDate: null,
    AuthorEnd: null,
  },
  {
    ID: 5021,
    Title: 'Статус',
    ColumnID: '2021',
    ColumnTitle: 'Направление 1',
    GroupID: '2022',
    GroupTitle: 'BOP',
    FactoryID: '4',
    FactoryTitle: 'Казань',
    Status: {
      Title: 'Завершено',
      ID: 2,
    },
    Month: '3',
    Year: '2025',
    CountYes: '332',
    CountQuestions: '1365',
    CountNull: '659',
    Modified: '2025-04-15T09:38:23.000Z',
    Author: {
      Name: 'System Account',
      ID: 1073741823,
      Email: '',
    },
    IsError: true,
    AutoEndDate: null,
    AuthorEnd: {
      Name: 'Гудков Евгений Олегович',
      ID: 296,
      Email: 'evgeniy.gudkov@abinbevefes.com',
    },
  },
  {
    ID: 5022,
    Title: 'Статус',
    ColumnID: '2021',
    ColumnTitle: 'Направление 1',
    GroupID: '2022',
    GroupTitle: 'BOP',
    FactoryID: '8',
    FactoryTitle: 'Омск',
    Status: {
      Title: 'Завершено',
      ID: 2,
    },
    Month: '3',
    Year: '2025',
    CountYes: '486',
    CountQuestions: '1365',
    CountNull: '662',
    Modified: '2025-04-10T00:34:56.000Z',
    Author: {
      Name: 'System Account',
      ID: 1073741823,
      Email: '',
    },
    IsError: true,
    AutoEndDate: null,
    AuthorEnd: {
      Name: 'Гудков Евгений Олегович',
      ID: 296,
      Email: 'evgeniy.gudkov@abinbevefes.com',
    },
  },
  {
    ID: 5023,
    Title: 'Статус',
    ColumnID: '3938',
    ColumnTitle: 'Логистика',
    GroupID: '5290',
    GroupTitle: 'BOP',
    FactoryID: '1',
    FactoryTitle: 'Владивосток',
    Status: {
      Title: 'Завершено',
      ID: 2,
    },
    Month: '3',
    Year: '2025',
    CountYes: '318',
    CountQuestions: '1526',
    CountNull: '958',
    Modified: '2025-04-10T01:13:43.000Z',
    Author: {
      Name: 'System Account',
      ID: 1073741823,
      Email: '',
    },
    IsError: true,
    AutoEndDate: null,
    AuthorEnd: {
      Name: 'Овчаренко Алексей Сергеевич',
      ID: 105,
      Email: 'aleksey.ovcharenko@abinbevefes.com',
    },
  },
  {
    ID: 5023,
    Title: 'Статус',
    ColumnID: '3938',
    ColumnTitle: 'Логистика',
    GroupID: '5290',
    GroupTitle: 'BOP',
    FactoryID: '5',
    FactoryTitle: 'Калуга',
    Status: {
      Title: 'Завершено',
      ID: 2,
    },
    Month: '3',
    Year: '2025',
    CountYes: '318',
    CountQuestions: '1526',
    CountNull: '958',
    Modified: '2025-04-10T01:13:43.000Z',
    Author: {
      Name: 'System Account',
      ID: 1073741823,
      Email: '',
    },
    IsError: true,
    AutoEndDate: null,
    AuthorEnd: {
      Name: 'Овчаренко Алексей Сергеевич',
      ID: 105,
      Email: 'aleksey.ovcharenko@abinbevefes.com',
    },
  },
];

export const columnsGOP = [
  {
    ID: 499,
    Title: 'Люди',
  },
  {
    ID: 2590,
    Title: 'Безопасность',
  },
  {
    ID: 30,
    Title: 'Качество',
  },
  {
    ID: 500,
    Title: 'Экология',
  },
  {
    ID: 3938,
    Title: 'Логистика',
  },
  {
    ID: 2021,
    Title: 'Направление 1',
  },
  {
    ID: 22,
    Title: 'CO2',
  },
];
